import { render, staticRenderFns } from "./FileDownloadButton.vue?vue&type=template&id=cecc1ccc&"
import script from "./FileDownloadButton.vue?vue&type=script&lang=ts&"
export * from "./FileDownloadButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports